import { ValueError } from "../error/ValueError.js";
/** Empty entity. */
export const EMPTY_ENTITY = [undefined, undefined];
export function splitEntity(entity) {
    const bits = entity.split(":", 2);
    if (bits[0] && bits[1])
        return bits;
    throw new ValueError("Invalid entity");
}
export function splitOptionalEntity(entity) {
    if (entity) {
        const bits = entity.split(":", 2);
        if (bits[0] && bits[1])
            return bits;
    }
    return EMPTY_ENTITY;
}
